"use strict";

import renderSidenotes from "./sidenotes/renderSidenotes";

const renderComponentSwaps = () => {
  const componentSwaps = [renderSidenotes];
  for (const swapFn of componentSwaps) {
    swapFn();
  }
};

export default renderComponentSwaps;
